import { render, staticRenderFns } from "./ContactRequestMessage.vue?vue&type=template&id=04283ffb"
import script from "./ContactRequestMessage.vue?vue&type=script&lang=js"
export * from "./ContactRequestMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports